/**
 * Dosya adından riser numarası (D-061): söküm raporu PDF'i "Riser No 47 Disassembly Traceability Record.pdf" ve söküm
 * girdisi "R047-disassembly-input-EN.xlsx" → "R047". Önce "Riser" etiketi (ardından isteğe bağlı No / No. / Number / #)
 * aranır; yoksa tek başına duran "R" + 1-3 hane. Dört ve daha çok haneli sayıdan numara kesilmez, 0 riser değildir.
 * Sınır açık yazılır, `\b` kullanılmaz: alt çizgi kelime karakteridir, "Scan_R047.pdf" R047 okunmalıdır.
 * Okunamazsa null (toplu yükleme o satırda riseri sorar).
 *
 * Sunucu (toplu söküm raporu yükleme) ve tarayıcı (PDF ile excel'i aynı satırda eşleme) aynı kuralı kullanır.
 */
export function sokumRnBul(metin) {
    const t = (metin ?? "").toUpperCase();
    const m = /(?<![A-Z0-9])RISER[\s_-]*(?:NO\.?|NUMBER|#)?[\s_:#-]*0*(\d{1,3})(?!\d)/.exec(t) ??
        /(?<![A-Z0-9])R[-_ ]?0*(\d{1,3})(?!\d)/.exec(t);
    const n = m ? Number(m[1]) : 0;
    return n > 0 ? `R${String(n).padStart(3, "0")}` : null;
}
//# sourceMappingURL=sokum-rn.js.map